<div class="wrapper">
  <div class="sidebar" data-color="rose" data-background-color="black" data-image="assets/dashboard/img/sidebar-1.jpg">
    <div class="sidebar-wrapper ps-container ps-theme-default" data-ps-id="09b6b478-b3c6-77b2-5f03-988825f5a037">
      <div class="user">
        <div class="photo" style="border: 2px solid mediumspringgreen">
          <img *ngIf="!profilePicture" src="assets/dashboard/img/faces/avatar.jpg">
          <img *ngIf="profilePicture" src="http://localhost:8000/{{profilePicture}}">
        </div>
        <div class="user-info">
          <a data-toggle="collapse" href="#collapseExample" class="username">
              <span>
                {{username}}
                <b class="caret"></b>
              </span>
          </a>
          <div class="collapse" id="collapseExample">
            <ul class="nav">
              <li class="nav-item">
                <a class="nav-link" (click)="setActiveNav(0); n_router.routeTo('profile', 'dashboard')">
                  <span class="sidebar-mini" style="color: deepskyblue"> MP </span>
                  <span class="sidebar-normal"> My Profile </span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="javascript:void(0)" (click)="logout()">
                  <span class="sidebar-mini text-danger"> LO </span>
                  <span class="sidebar-normal"> Log Out </span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <ul class="nav">
        <li class="nav-item">
          <a class="nav-link" routerLink="/dashboard" (click)="setActiveNav(2)">
            <i class="material-icons">dashboard</i>
            <p> Dashboard </p>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" data-toggle="collapse" href="#pagesExamples" (click)="setActiveNav(3)">
            <i class="material-icons">image</i>
            <p> Announces
              <b class="caret"></b>
            </p>
          </a>
          <div class="collapse" id="pagesExamples">
            <ul class="nav">
              <li class="nav-item ">
                <a class="nav-link" (click)="setActiveNav(4); n_router.routeTo('all', 'dashboard')">
                  <span class="sidebar-mini text-success"> <i class="material-icons text-success">Info</i> </span>
                  <span class="sidebar-normal">All Announces</span>
                </a>
              </li>
              <li class="nav-item ">
                <a class="nav-link" (click)="setActiveNav(5); n_router.routeTo('announces', 'dashboard')">
                  <span class="sidebar-mini text-success"> <i class="material-icons text-success">how_to_reg</i> </span>
                  <span class="sidebar-normal">My Announces</span>
                </a>
              </li>
              <li class="nav-item ">
                <a class="nav-link" (click)="setActiveNav(6); n_router.routeTo('favorites', 'dashboard')">
                  <span class="sidebar-mini text-success"> <i class="material-icons text-success">star</i>  </span>
                  <span class="sidebar-normal">My Favorites</span>
                </a>
              </li>
              <li class="nav-item ">
                <a class="nav-link" (click)="setActiveNav(7); n_router.routeTo('add-announce', 'dashboard', true)">
                  <span class="sidebar-mini text-success"> <i class="material-icons text-success">add</i> </span>
                  <span class="sidebar-normal">New Announce</span>
                </a>
              </li>
            </ul>
          </div>
        </li>
        <li class="nav-item ">
          <a class="nav-link" data-toggle="collapse" href="#componentsExamples">
            <i class="material-icons">apps</i>
            <p> Agents
              <b class="caret"></b>
            </p>
          </a>
<!--          <div class="collapse" id="componentsExamples">-->
<!--            <ul class="nav">-->
<!--              <li class="nav-item ">-->
<!--                <a class="nav-link" data-toggle="collapse" href="#componentsCollapse">-->
<!--                  <span class="sidebar-mini"> MLT </span>-->
<!--                  <span class="sidebar-normal"> Multi Level Collapse-->
<!--                      <b class="caret"></b>-->
<!--                    </span>-->
<!--                </a>-->
<!--                <div class="collapse" id="componentsCollapse">-->
<!--                  <ul class="nav">-->
<!--                    <li class="nav-item ">-->
<!--                      <a class="nav-link" href="#0">-->
<!--                        <span class="sidebar-mini"> E </span>-->
<!--                        <span class="sidebar-normal"> Example </span>-->
<!--                      </a>-->
<!--                    </li>-->
<!--                  </ul>-->
<!--                </div>-->
<!--              </li>-->
<!--              <li class="nav-item ">-->
<!--                <a class="nav-link" href="components/buttons.html">-->
<!--                  <span class="sidebar-mini"> B </span>-->
<!--                  <span class="sidebar-normal"> Buttons </span>-->
<!--                </a>-->
<!--              </li>-->
<!--              <li class="nav-item ">-->
<!--                <a class="nav-link" href="components/grid.html">-->
<!--                  <span class="sidebar-mini"> GS </span>-->
<!--                  <span class="sidebar-normal"> Grid System </span>-->
<!--                </a>-->
<!--              </li>-->
<!--              <li class="nav-item ">-->
<!--                <a class="nav-link" href="components/panels.html">-->
<!--                  <span class="sidebar-mini"> P </span>-->
<!--                  <span class="sidebar-normal"> Panels </span>-->
<!--                </a>-->
<!--              </li>-->
<!--              <li class="nav-item ">-->
<!--                <a class="nav-link" href="components/sweet-alert.html">-->
<!--                  <span class="sidebar-mini"> SA </span>-->
<!--                  <span class="sidebar-normal"> Sweet Alert </span>-->
<!--                </a>-->
<!--              </li>-->
<!--              <li class="nav-item ">-->
<!--                <a class="nav-link" href="components/notifications.html">-->
<!--                  <span class="sidebar-mini"> N </span>-->
<!--                  <span class="sidebar-normal"> Notifications </span>-->
<!--                </a>-->
<!--              </li>-->
<!--              <li class="nav-item ">-->
<!--                <a class="nav-link" href="components/icons.html">-->
<!--                  <span class="sidebar-mini"> I </span>-->
<!--                  <span class="sidebar-normal"> Icons </span>-->
<!--                </a>-->
<!--              </li>-->
<!--              <li class="nav-item ">-->
<!--                <a class="nav-link" href="components/typography.html">-->
<!--                  <span class="sidebar-mini"> T </span>-->
<!--                  <span class="sidebar-normal"> Typography </span>-->
<!--                </a>-->
<!--              </li>-->
<!--            </ul>-->
<!--          </div>-->
        </li>
        <li class="nav-item ">
          <a class="nav-link" data-toggle="collapse" (click)="n_router.routeTo('map', 'dashboard', true)">
            <i class="material-icons">room</i>
            <p> Map
            </p>
          </a>
        </li>
        <li class="nav-item ">
          <a class="nav-link" data-toggle="modal" data-target="#contactus">
            <i class="material-icons">email</i>
            <p> Contact us
            </p>
          </a>
        </li>
<!--        <li class="nav-item ">-->
<!--          <a class="nav-link" data-toggle="collapse" href="#formsExamples">-->
<!--            <i class="material-icons">content_paste</i>-->
<!--            <p> Forms-->
<!--              <b class="caret"></b>-->
<!--            </p>-->
<!--          </a>-->
<!--          <div class="collapse" id="formsExamples">-->
<!--            <ul class="nav">-->
<!--              <li class="nav-item ">-->
<!--                <a class="nav-link" href="forms/regular.html">-->
<!--                  <span class="sidebar-mini"> RF </span>-->
<!--                  <span class="sidebar-normal"> Regular Forms </span>-->
<!--                </a>-->
<!--              </li>-->
<!--              <li class="nav-item ">-->
<!--                <a class="nav-link" href="forms/extended.html">-->
<!--                  <span class="sidebar-mini"> EF </span>-->
<!--                  <span class="sidebar-normal"> Extended Forms </span>-->
<!--                </a>-->
<!--              </li>-->
<!--              <li class="nav-item ">-->
<!--                <a class="nav-link" href="forms/validation.html">-->
<!--                  <span class="sidebar-mini"> VF </span>-->
<!--                  <span class="sidebar-normal"> Validation Forms </span>-->
<!--                </a>-->
<!--              </li>-->
<!--              <li class="nav-item ">-->
<!--                <a class="nav-link" href="forms/wizard.html">-->
<!--                  <span class="sidebar-mini"> W </span>-->
<!--                  <span class="sidebar-normal"> Wizard </span>-->
<!--                </a>-->
<!--              </li>-->
<!--            </ul>-->
<!--          </div>-->
<!--        </li>-->
<!--        <li class="nav-item ">-->
<!--          <a class="nav-link" data-toggle="collapse" href="#tablesExamples">-->
<!--            <i class="material-icons">grid_on</i>-->
<!--            <p> Tables-->
<!--              <b class="caret"></b>-->
<!--            </p>-->
<!--          </a>-->
<!--          <div class="collapse" id="tablesExamples">-->
<!--            <ul class="nav">-->
<!--              <li class="nav-item ">-->
<!--                <a class="nav-link" href="tables/regular.html">-->
<!--                  <span class="sidebar-mini"> RT </span>-->
<!--                  <span class="sidebar-normal"> Regular Tables </span>-->
<!--                </a>-->
<!--              </li>-->
<!--              <li class="nav-item ">-->
<!--                <a class="nav-link" href="tables/extended.html">-->
<!--                  <span class="sidebar-mini"> ET </span>-->
<!--                  <span class="sidebar-normal"> Extended Tables </span>-->
<!--                </a>-->
<!--              </li>-->
<!--              <li class="nav-item ">-->
<!--                <a class="nav-link" href="tables/datatables.net.html">-->
<!--                  <span class="sidebar-mini"> DT </span>-->
<!--                  <span class="sidebar-normal"> DataTables.net </span>-->
<!--                </a>-->
<!--              </li>-->
<!--            </ul>-->
<!--          </div>-->
<!--        </li>-->
<!--        <li class="nav-item ">-->
<!--          <a class="nav-link" data-toggle="collapse" href="#mapsExamples">-->
<!--            <i class="material-icons">place</i>-->
<!--            <p> Maps-->
<!--              <b class="caret"></b>-->
<!--            </p>-->
<!--          </a>-->
<!--          <div class="collapse" id="mapsExamples">-->
<!--            <ul class="nav">-->
<!--              <li class="nav-item ">-->
<!--                <a class="nav-link" href="maps/google.html">-->
<!--                  <span class="sidebar-mini"> GM </span>-->
<!--                  <span class="sidebar-normal"> Google Maps </span>-->
<!--                </a>-->
<!--              </li>-->
<!--              <li class="nav-item ">-->
<!--                <a class="nav-link" href="maps/fullscreen.html">-->
<!--                  <span class="sidebar-mini"> FSM </span>-->
<!--                  <span class="sidebar-normal"> Full Screen Map </span>-->
<!--                </a>-->
<!--              </li>-->
<!--              <li class="nav-item ">-->
<!--                <a class="nav-link" href="maps/vector.html">-->
<!--                  <span class="sidebar-mini"> VM </span>-->
<!--                  <span class="sidebar-normal"> Vector Map </span>-->
<!--                </a>-->
<!--              </li>-->
<!--            </ul>-->
<!--          </div>-->
<!--        </li>-->
<!--        <li class="nav-item ">-->
<!--          <a class="nav-link" href="widgets.html">-->
<!--            <i class="material-icons">widgets</i>-->
<!--            <p> Widgets </p>-->
<!--          </a>-->
<!--        </li>-->
<!--        <li class="nav-item ">-->
<!--          <a class="nav-link" href="charts.html">-->
<!--            <i class="material-icons">timeline</i>-->
<!--            <p> Charts </p>-->
<!--          </a>-->
<!--        </li>-->
<!--        <li class="nav-item ">-->
<!--          <a class="nav-link" href="calendar.html">-->
<!--            <i class="material-icons">date_range</i>-->
<!--            <p> Calendar </p>-->
<!--          </a>-->
<!--        </li>-->
      </ul>
      <div class="ps-scrollbar-x-rail" style="left: 0px; bottom: 0px;"><div class="ps-scrollbar-x" tabindex="0" style="left: 0px; width: 0px;"></div></div><div class="ps-scrollbar-y-rail" style="top: 0px; right: 0px;"><div class="ps-scrollbar-y" tabindex="0" style="top: 0px; height: 0px;"></div></div></div>
    <div class="sidebar-background" style="background-image: url(../../assets/dashboard/img/sidebar-1.jpg) "></div></div>
  <div class="main-panel">
    <app-dashboard-header></app-dashboard-header>

    <!-- DASHBOARD CONTENT -->
    <router-outlet name="dashboard"></router-outlet>

    <!-- DASHBOARD FOOTER -->
    <footer class="footer">
      <div class="container-fluid">
        <nav class="float-left">
          <ul>
            <li>
              <a href="javascript:void(0)" data-toggle="modal" data-target="#contactus">
                Contact Us
              </a>
            </li>
            <li>
              <a href="javascript:void(0)" data-toggle="modal" data-target="#aboutus">
                About Us
              </a>
            </li>
          </ul>
        </nav>
        <div class="copyright float-right text-white">
          &copy;
          <script>
              document.write(new Date().getFullYear())
          </script>, made with <i class="material-icons">favorite</i> by Group Akinators for a better web.
        </div>
      </div>
    </footer>
  </div>
</div>

<div class="modal fade" id="contactus">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <span class="text-danger" *ngIf="error">{{error}}</span>
      <!-- Modal Header -->
      <div class="modal-header">

        <h5 class="modal-title">Contactez nous</h5>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>
      <!-- Modal body -->
      <div class="modal-body">
        <div class="container">

          <div class="row">
            <div class="col-lg-6 col-md-6">
              <span class="text-danger" id="contact-subject-error"></span>
              <div class="form-group">
                <input id="subject" type="text" class="form-control" name="subject" placeholder="Objectif" [(ngModel)]="subject" />
              </div>
            </div>

            <div class="col-lg-6 col-md-6">
              <span class="text-danger" id="contact-email-error"></span>
              <div class="form-group">
                <input id="email" type="text" class="form-control" name="email" placeholder="email" [(ngModel)]="email" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class=" col-lg-6 col-md-12 ">
              <span class="text-danger" id="contact-comment-error"></span>
              <div class="form-group ">
                <textarea id="comment" class="form-control" name="comment" placeholder="Your Message..." [(ngModel)]="comment"></textarea>
              </div>
            </div>
          </div>
          <div class="d-flex flex-row justify-content-center ">
            <button type="submit " class="btn btn-primary " (click)="contactUs()"><img src="../../assets/icons/footer/send.png ">Submit</button>
            <!--<input type="submit" (click)="contactUs()" class="btn connexion-button" value="Envoyer">-->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="aboutus">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header">

        <h5 class="modal-title">Equipe du Projet</h5>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>
      <!-- Modal body -->
      <div class="modal-body">
        <div class="team-section text-center my-5 w-97 m-auto" id="team">
          <h2 class="h1-responsive font-weight-bold my-5 text-primary">Development team</h2>
          <p class="grey-text w-responsive mx-auto mb-5">Ce site a été développé par un groupe de 7 étudiants de master qualité du logiciel fes, sous les principes de gestion de projet agile. Travail encadré par Prof Mr Ahmed Azough</p>
          <div class="row" >
            <div class="col-lg-4 col-md-6 mb-lg-0 mb-5" *ngFor="let membre of team">
              <div class="avatar mx-auto">
                <img src="../../assets/pictures/team/{{membre.photo}}" class="rounded-circle z-depth-1 w-50"
                     alt="Photo of {{ membre.name}}">
              </div>
              <h5 class="font-weight-bold mt-4 mb-3">{{membre.name }} : {{membre.age}} ans</h5>
              <p class="text-uppercase text-primary "><strong>{{membre.job}}</strong></p>
              <p class="grey-text">{{membre.rating}}</p>
              <ul class="list-unstyled mb-2">
                <a class="p-2 fa-lg tw-ic" href="{{membre.linkedin}}">
                  <span class="material-icons">link</span>
                </a>
              </ul>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>


